import React, { useEffect, useState } from 'react';
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
import CustomDataTable from '../components/CustomDataTable'
import '../components/Common.css';

const DepartmentWisePunch = () => {
    const empcode = localStorage.getItem('empcode');
    const [data, setData] = useState([]);
    const { setLoading } = useLoading();
    const [filters, setFilters] = useState({
        CompanyName: '',
        PlantName: '',
        VenderName: '',
        DepartmentName: '',
    });
    const [departments, setDepartments] = useState([]);
    const [plant, setPlant] = useState([]);
    const [company, setCompany] = useState([]);
    const [vender, setVender] = useState([]);

    // 🔹 Toggles for filters and table
    const [showFilters, setShowFilters] = useState(true);
    const [showTable, setShowTable] = useState(true);

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [plantRes, companyRes, venderRes] = await Promise.all([
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany("User"),
                EmployeeProcessService.getVender("User"),
               
            ]);
            if (plantRes?.data?.statusCode === 200) setPlant(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
           
        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const handlePlantChange = async (e) => {
        const plantId = e.target.value;
        setFilters(prev => ({ ...prev, PlantName: plantId, DepartmentName: "" }));
        setDepartments([]);
        if (!plantId) return;
        try {

            const res = await EmployeeProcessService.getDepartment(empcode, plantId);
            if (res?.data?.statusCode === 200) {
                setDepartments(res.data.result);
            } else {
                setDepartments([]);
            }
        } catch (error) {
            console.error("Error loading departments:", error);
        }
    };

    const formatDate = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (isNaN(date)) return value;
        return date.toLocaleDateString("en-GB");
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await EmployeeProcessService.getDepartmentWisePunch(filters);
           
            if (response.data.statusCode === 200 && response.data.result.length > 0) {
                setData(response.data.result);
            } else {
                setData([]);
                alert("No record found");
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const applyFilters = () => {
        if (filters.CompanyName === "") {
            alert("Please select Company.");
            return;
        }
        // if (filters.PlantName === "") {
        //     alert("Please select Plant.");
        //     return;
        // }
        if (filters.DoJStart && filters.DoJEnd && filters.DoJStart > filters.DoJEnd) {
            toast.error("Start date cannot be after end date.");
            return;
        }
        fetchData();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const transformDataForExcel = (data) => {
        return data.map(row => {
            const newRow = {};
            Object.keys(row).forEach(key => {
                if (row[key] && /^\d{4}-\d{2}-\d{2}T/.test(row[key])) {
                    newRow[key] = formatDate(row[key]);
                } else {
                    newRow[key] = row[key];
                }
            });
            return newRow;
        });
    };

    const downloadExcel = () => {
        const formattedData = transformDataForExcel(data);
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");
        XLSX.writeFile(workbook, "DepartmentWiseTodayPunch.xlsx");
    };

    return (
        <div className="container mt-1">

            {/* 🔹 Section 1: Heading */}
            <div className="mb-1 p-2 bg-light rounded">
                <h7 className="m-0 text-primary">Department Wise Today Punch</h7>
            </div>

            {/* 🔹 Section 2: Filters with toggle */}
            <div
                className="d-flex justify-content-between align-items-center mb-1 p-2 bg-secondary bg-opacity-10 rounded"
                style={{ cursor: "pointer" }}
                onClick={() => setShowFilters(!showFilters)}
            >
                <h7 className="m-0">Filters</h7>
                <span style={{ fontSize: "11px" }}>{showFilters ? "▲" : "▼"}</span>
            </div>

            {showFilters && (
                <>
                    <div className="row filter-section">
                        {/* Company */}
                        <div className="col-md-3">
                            <label className="filter-label text-primary">Select Company</label>
                            <select name="CompanyName" value={filters.CompanyName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Company</option>
                                {company.map(comp => (
                                    <option key={comp.id} value={comp.id}>{comp.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* Plant */}
                        <div className="col-md-3">
                            <label className="filter-label text-primary">Select Plant</label>
                            <select name="PlantName" value={filters.PlantName} onChange={handlePlantChange}
                                className="form-select filter-input">
                                <option value="">Select Plant</option>
                                {plant.map(plan => (
                                    <option key={plan.id} value={plan.id}>{plan.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* Vendor */}
                        <div className="col-md-3">
                            <label className="filter-label text-primary">Select Vendor</label>
                            <select name="VenderName" value={filters.VenderName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Vendor</option>
                                {vender.map(ven => (
                                    <option key={ven.id} value={ven.id}>{ven.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* Department */}
                        <div className="col-md-3">
                            <label className="filter-label text-primary">Select Department</label>
                            <select name="DepartmentName" value={filters.DepartmentName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Department</option>
                                {departments.map(dept => (
                                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                                ))}
                            </select>
                        </div>

{/*                         
                        <div className="row mb-3 filter-section">
                            <div className="col-md-3">
                                <label className="filter-label text-primary">DOJ From</label>
                                <input type="date" name="DoJStart" value={filters.DoJStart}
                                    onChange={handleChange} className="form-control filter-input" />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">DOJ To</label>
                                <input type="date" name="DoJEnd" value={filters.DoJEnd}
                                    onChange={handleChange} className="form-control filter-input" />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">Employee Code</label>
                                <input name="EmployeeCode" value={filters.EmployeeCode}
                                    placeholder="Employee Code" onChange={handleChange}
                                    className="form-control filter-input" />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">Employee Name</label>
                                <input name="EmployeeName" value={filters.EmployeeName}
                                    placeholder="Employee Name" onChange={handleChange}
                                    className="form-control filter-input" />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">Select Skill</label>
                                <select name="Grade" value={filters.Grade} onChange={handleChange}
                                    className="form-control filter-input">
                                    <option value="">Select Skill</option>
                                    {grade.map(grd => (
                                        <option key={grd.id} value={grd.name}>{grd.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-3">
                                <label className="text-primary">Employee Status</label>
                                <select className="form-select" name="EmployeeStatus" value={filters.EmployeeStatus} onChange={handleChange}>
                                   
                                    <option value="1">Active</option>
                                    <option value="0">In Active</option>
                                </select>
                            </div>
                        </div> */}
                    </div>

                    <div className="d-flex gap-2 mb-3 flex-wrap">
                        <button className="btn btn-primary filter-btn" onClick={applyFilters}>Search</button>
                        {data.length > 0 && (
                            <button className="btn btn-success filter-btn" onClick={downloadExcel}>Download Excel</button>
                        )}
                    </div>
                </>
            )}

            {/* 🔹 Section 3: Data Table with toggle */}
            <div
                className="d-flex justify-content-between align-items-center mb-1 p-1 bg-secondary bg-opacity-10 rounded"
                style={{ cursor: "pointer" }}
                onClick={() => setShowTable(!showTable)}
            >
                <h7 className="m-0">Data</h7>
                <span style={{ fontSize: "11px" }}>{showFilters ? "▲" : "▼"}</span>
            </div>

            {showTable && (
                <div className="table-responsive">
                    <CustomDataTable data={data} title="Employee List" />
                </div>
            )}
        </div>
    );
};

export default DepartmentWisePunch;
